<div class="payer-and-currency row">
    <div class="payer-container">
        <app-payer [title]="title" [payer]="payer" [currency]="currency"></app-payer>
    </div>
</div>
<div class="description row" [innerHTML]="description"></div>